/**
 * @argus/web - React frontend for ArgusAI
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { routeTree } from './routeTree.gen';
import { queryClient } from './lib/query-client';
// Configure Monaco Editor to use local assets (must be before any Monaco components)
import './lib/monaco-config';
// Install the console error ring-buffer BEFORE the router mounts so we
// capture any render-time errors as bug-report context.
import { installConsoleErrorTracker } from './lib/console-error-tracker';
installConsoleErrorTracker();

// Create router instance
const router = createRouter({ routeTree });

// Type-safe router
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);

export const WEB_VERSION = '0.0.1';
